/**
 * @file: 层板吸附到货架
 * @author: xiaolong.huang@dmall.com
 */

import * as Toolkit from '../../../toolkit/index';
import Utils from '../../../utils/util';

interface StuckToShelfParams {
    transfer: Transfer,
    shelfsRect: Rect[]
};

function stuckToShelf(params: StuckToShelfParams): void {
    let dragCube: CubeId = params.transfer.findPressCube();
    let dragCubePaintCoordinate: CubePaintCoordinate = params.transfer.getTargetCubePaintCoordinate(dragCube);
    let touchRect: Rect = {
        left: dragCubePaintCoordinate.left,
        top: dragCubePaintCoordinate.top,
        width: dragCubePaintCoordinate.width,
        height: dragCubePaintCoordinate.height
    };
    let rect: Rect = Toolkit.stuckToRectInside(touchRect, params.shelfsRect, 10);
    let dis: number = Utils.math(rect.left, dragCubePaintCoordinate.left, '-');

    params.transfer.transferRect.left = Utils.math(params.transfer.transferRect.left, dis, '+');
}

export {
    stuckToShelf
};
